import { Alert, Divider, Typography } from "antd";
import { useState } from "react";
import { ConfirmDelete } from "../../../../../common/components/modal/confirmDelete/confirmDelete";

const { Text } = Typography;

export default function DeleteCandidateModal({
  candidateActivity,
  open,
  loading,
  onCancel,
  onDelete,
}) {
  const [deleteResponse, setDeleteResponse] = useState(null);
  const candidate = candidateActivity?.candidate;
  const name = [candidate?.firstName, candidate?.lastName]
    .filter(Boolean)
    .join(" ");

  const onConfirm = async () => {
    setDeleteResponse(null);
    try {
      await onDelete();
    } catch (e) {
      setDeleteResponse(e.message);
      throw e;
    }
  };

  return (
    <ConfirmDelete
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      loading={loading}
      title="Are you sure?"
      okText="Delete Candidate"
    >
      The following candidate will be deleted:
      <Divider style={{ margin: 0, marginBottom: 10, marginTop: 10 }} />
      <div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <strong>
            <font style={{ fontSize: 26, color: "#278dc0" }}>{name || "—"}</font>
          </strong>
        </div>
        <div>
          <strong>Email: </strong>
          {candidate?.email}
        </div>
        <div>
          <strong>Location: </strong>
          {candidate?.location}
        </div>
      </div>
      {deleteResponse && (
        <>
          <Divider style={{ margin: 0, marginTop: 30 }} />
          <div style={{ marginTop: 20 }}>
            <Alert
              style={{ whiteSpace: "break-spaces" }}
              showIcon
              type="error"
              message={
                <>
                  <strong>Error:&nbsp;</strong>
                  <Text>{deleteResponse}</Text>
                </>
              }
            />
          </div>
        </>
      )}
    </ConfirmDelete>
  );
}
